import useWebSocket from 'common/hooks/useWebSocket';
import { sortBy, uniqBy } from 'lodash';
import { useEffect, useMemo, useState } from 'react';

const useShipmentWebSocket = (shipmentId) => {
  const { socket } = useWebSocket();
  const [currentUsers, setCurrentUsers] = useState([]);

  useEffect(() => {
    if (!shipmentId || !socket?.connected) return undefined;

    socket.emit('join_shipment_dialog', { shipmentId });

    socket.on('shipment_dialog_joined', (data) => {
      if (data.shipmentId && data.currentUsers) {
        setCurrentUsers(uniqBy(sortBy(data.currentUsers, 'email'), 'email'));
      }
    });

    socket.on('user_joined_shipment_dialog', (data) => {
      if (data.shipmentId && data.allUsersInRoom) {
        setCurrentUsers(uniqBy(sortBy(data.allUsersInRoom, 'email'), 'email'));
      }
    });

    socket.on('user_left_shipment_dialog', (data) => {
      if (data.remainingUsers) {
        setCurrentUsers(uniqBy(sortBy(data.remainingUsers, 'email'), 'email'));
      }
    });

    return () => {
      socket.emit('leave_shipment_dialog', { shipmentId });
      socket.off('shipment_dialog_joined');
      socket.off('user_joined_shipment_dialog');
      socket.off('user_left_shipment_dialog');
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shipmentId, socket, socket?.connected]);

  return useMemo(() => ({ currentUsers }), [currentUsers]);
};

export default useShipmentWebSocket;
